/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_UnknownInputs */



/**
* | output |
* | --- |
* | "the reason was not recorded" |
*
* @param {Twda_Failed_UnknownInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_unknown = /** @type {((inputs?: Twda_Failed_UnknownInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_UnknownInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("la raison n'a pas été enregistrée")
	if (locale === "es") return /** @type {LocalizedString} */ ("el motivo no quedó registrado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o motivo não foi registrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("il motivo non è stato registrato")
	return /** @type {LocalizedString} */ ("the reason was not recorded")
});